import React from 'react'
import PropTypes from 'prop-types'

const VARIABLE_NAME = 'variable_name'
const VARIABLE_VALUE = 'variable_value'

const ContentVariableMarkField = ({ mark }) => {
  const { question } = mark

  if (!question[VARIABLE_NAME])
    return <p className="text-muted my-2">Variable non disponible</p>

  const emptyValue = <span className="text-muted">Aucune valeur définie</span>

  return (
    <p className="tw:mb-0!">
      <b>
        {`${question[VARIABLE_NAME]} :`}
      </b>
      {' '}
      {question[VARIABLE_VALUE] ? question[VARIABLE_VALUE] : emptyValue}
    </p>
  )
}

ContentVariableMarkField.propTypes = {
  mark: PropTypes.shape({
    question: PropTypes.shape({
      [VARIABLE_NAME]: PropTypes.string,
      [VARIABLE_VALUE]: PropTypes.string
    })
  }).isRequired
}

export default ContentVariableMarkField
